import { Type } from "class-transformer";
import { EditProjectContactPersonDto } from "./EditProjectContactPersonDto";
import { EditProjectRoleDto } from "./EditProjectRoleDto";

export class EditProjectResponsibilitesDto {
    projectId = 0;
    @Type(() => EditProjectRoleDto)
    roles: EditProjectRoleDto[];
    @Type(() => EditProjectContactPersonDto)
    contactPersons: EditProjectContactPersonDto[];
}
